import React, { useEffect } from "react";
import LayoutTemplate from "@openstack_dev/gatsby-theme-marketing-oif-core/src/components/Layout";
import { doLoginBasicLogin } from "openstack-uicore-foundation/lib/security/methods";
import { useSelector } from "react-redux";
import { getBackURL } from "../utils/url";

const Layout = ({ children }) => {
  const isLoggedUser = useSelector(
    (state) => state.loggedUserState.isLoggedUser
  );

  const checkLoginStatus = async () => {
    try {
      const response = await fetch("/oidc/session/whoami", {
        method: "GET",
        credentials: "same-origin"
      });

      if (response.ok) {
        const data = await response.json();
        if (
          data.email &&
          typeof data.email === "string" &&
          /\S+@\S+\.\S+/.test(data.email)
        ) {
          doLoginBasicLogin(getBackURL(), data.email);
        } else {
          console.warn(
            "Invalid or missing email in login response:",
            data.email
          );
        }
      }
    } catch (error) {
      console.error(
        "Failed to check login status. Possible network error or invalid response.",
        {
          error,
          attemptedUrl: "/oidc/session/whoami"
        }
      );
    }
  };

  useEffect(() => {
    if (!isLoggedUser) checkLoginStatus();
  }, [isLoggedUser]);

  return <LayoutTemplate>{children}</LayoutTemplate>;
};

export default Layout;
